<template>
  <section class="school-new-quality">
    <main-license
      title="надежность и&nbsp;качество образования"
      :have-small-text="haveSmallText"
    />
    <div class="school-new-quality__blocks">
      <div class="school-new-quality__block-1">
        <h6>современные стандарты обучения</h6>
        <p>
          учебные материалы соответствуют последним образовательным стандартам.
          Преподаватели школы регулярно проходят курсы повышения квалификации и навыков
        </p>
      </div>
      <div class="school-new-quality__block-2">
        <h6>вручение аттестатов на&nbsp;выпускном 2024</h6>
        <video
          src="/v2/school-new/quality/video.mp4"
          autoplay
          :muted="videoMuted"
          playsinline
          preload="none"
          loop
        />
        <button
          class="m-btn video__mute"
          @click="videoMuted = !videoMuted"
        >
          <img :src="`/v2/main/goal/${videoMuted ? 'mute' : 'no-mute' }.svg`" alt="mute">
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import MainLicense from '../main/MainSuccess.vue';

export default {
  name: 'SchoolNewQuality',
  components: { MainLicense },
  props: {
    haveSmallText: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    videoMuted: true,
  }),
};
</script>

<style scoped lang="scss">

.school-new-quality {
  ::v-deep(.main-title) {
    max-width: calc(var(--scale) * 910);
  }

  .school-new-quality__blocks  {
    display: flex;
    gap: calc(var(--scale) * 20);
    margin-top: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 8);
      margin-top: calc(var(--scale) * 8);
    }

    @include media-down($size-mobile) {
      flex-direction: column;
    }
  }

  .school-new-quality__block-1 {
    background-image: url("/v2/school-new/quality/standart.webp");
    background-size: 100% 100%;
    padding: calc(var(--scale) * 32) calc(var(--scale) * 40) calc(var(--scale) * 40);
    width: calc(var(--scale) * 600);
    flex-shrink: 0;
    height: calc(var(--scale) * 720);

    @include media-down($size-tablet) {
      width: calc(50% - var(--scale) * 4);
      padding: calc(var(--scale) * 16);
      height: calc(var(--scale) * 512);
      background-image: url("/v2/school-new/quality/standart-tablet.webp");
    }

    @include media-down($size-mobile) {
      width: 100%;
    }

    h6 {
      margin-bottom: calc(var(--scale) * 8);
      font-weight: 500;
      font-size: calc(var(--scale) * 64);
      line-height: 95%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 40);
        line-height: 110%;
        letter-spacing: -0.04em;
      }
    }

    p {
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 18);
      }
    }
  }

  .school-new-quality__block-2 {
    width: 100%;
    position: relative;
    border-radius: calc(var(--scale) * 40);
    overflow: hidden;
    height: calc(var(--scale) * 720);

    @include media-down($size-tablet) {
      border-radius: calc(var(--scale) * 24);
      height: calc(var(--scale) * 512);
    }

    h6 {
      position: absolute;
      top: calc(var(--scale) * 32);
      left: 50%;
      transform: translateX(-50%);
      width: calc(var(--scale) * 735);

      font-weight: 500;
      font-size: calc(var(--scale) * 64);
      line-height: 95%;
      letter-spacing: -0.02em;
      color: #FFFFFF;
      text-align: center;

      @include media-down($size-tablet) {
        border-radius: calc(var(--scale) * 24);
        top: calc(var(--scale) * 16);
        left: calc(var(--scale) * 16);
        transform: none;
        width: calc(100% - var(--scale) * 32);
        font-size: calc(var(--scale) * 40);
        line-height: 110%;
        letter-spacing: -0.04em;
        text-align: left;
      }
    }

    button {
      position: absolute;
      top: calc(var(--scale) * 50);
      right: calc(var(--scale) * 40);
      width: calc(var(--scale) * 32);
      aspect-ratio: 1/1;

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 24);
        top: calc(var(--scale) * 28);
        right: calc(var(--scale) * 27);
      }

      img {
        width: 100%;
      }
    }

    video {
      line-height: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

</style>
